// extracted by mini-css-extract-plugin
export default {"grid-view":"ItemList_grid-view__7CLSi","list-view":"ItemList_list-view__br9Lq"};